<template>
  <div id="question-type">
    <div class="wrap">
      <div class="function-type">
        <div class="title">请选择具体的功能模块</div>
        <div class="type-list">
          <div class="type-item" v-for="(item, index) in typeList" :key="item.id" :class="[activeIndex === item.id ? 'active' : '']" @click="selectType(item.id)">{{ item.type }}</div>
          <div class="type-item fill"></div>
        </div>
      </div>
      <div class="submit">
        <div class="define" @click="changeType">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'questionType',
  props: {
    typeId: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      typeList: [
        {id: -1, type: '不限'},
        {id: 1, type: '任务'},
        {id: 13, type: '项目'},
        {id: 4, type: '绩效'},
        {id: 2, type: 'CRM'},
        {id: 3, type: '进销存'},
        {id: 5, type: '审批'},
        {id: 6, type: '考勤'},
        {id: 7, type: '通知'},
        {id: 8, type: '数据'},
        {id: 9, type: '人事'},
        {id: 10, type: '薪酬'},
        {id: 11, type: '通讯录'},
        {id: 12, type: '人脉'},
        {id: 0, type: '其他'}
      ],
      activeIndex: -1
    }
  },
  created () {
    this.activeIndex = this.typeId
  },
  methods: {
    selectType (typeId) {
      this.activeIndex = typeId
    },
    changeType () {
      this.$emit('changeQuestionType', this.activeIndex)
    }
  },
  watch: {
    typeId (val) {
      this.activeIndex = val
    }
  }
}
</script>

<style scoped>
#question-type {
  background: rgba(0, 0, 0, 0.4);
}
.wrap {
  /*width: 377px;*/
  width: 100%;
  height: 304px;
}
.function-type {
  box-sizing: border-box;
  /*width: 377px;*/
  width: 100%;
  height: 254px;
  padding: 12px 26px 17px;
  background: #fff;
}
.title {
  height: 20px;
  margin-bottom: 9px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
  letter-spacing: -0.34px;
}
.type-list {
  display: flex;
  height: 196px;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
}
.type-item {
  width: 22%;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  text-align: center;
  background: #EFEFEF;
  cursor: pointer;
}
.fill {
  opacity: 0;
  background: rgba(0 ,0 ,0, 0)
}
.active {
  color: #fff;
  background: #4A90E2;
}

.submit {
  box-sizing: border-box;
  display: flex;
  flex-direction: row-reverse;
  /*width: 377px;*/
  width: 100%;
  height: 50px;
  padding: 10px 16px;
  background: #EFEFEF;
}
.define {
  width: 70px;
  height: 30px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  background: #4A90E2;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/questionType/question-type.vue